// import { APIFetchStores } from "../../../helpers/filterstores.ts";
// // Action creator
// export const fetchStoreData = (token) => {
//   return async (dispatch) => {
//     try {
//       const res = await APIFetchStores("all", token);
//       dispatch({ type: "Set_filter_data", payload: res.data });
//     } catch (error) {
//       console.log(error);
//     }
//   };
// };
import { APIFetchStores } from "../../../helpers/filterstores.ts";
import { setStoreData } from "../../../core/redux/filters/filter.action.jsx";
// Action creator
export const fetchStoreData = (token) => {
  return async (dispatch) => {
    try {
      const res = await APIFetchStores("all", token);
      dispatch({ type: "Set_filter_data", payload: res.data });
      let selectedStore = "";
      if(res?.data?.dataAccessStores[0]?.storeNumber)
        {
          console.log('store1',res?.data?.dataAccessStores[0]?.storeNumber)
          selectedStore = res?.data?.dataAccessStores[0]?.storeNumber;
        }
        else if(res?.data?.myStores[0]?.storeNumber)
        {
          selectedStore = res?.data?.myStores[0].storeNumber?res.data.myStores[0].storeNumber:null;
        }
        else
        {
          selectedStore = "";
        }


      dispatch(setStoreData({ selectedLocationStore: [selectedStore] }));
      
    } catch (error) {
      console.log(error);
    }
  };
};
export const setApiStoreActhual = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "Set_store_data_api", payload });
  };
};
